import { useEffect, useState, type ReactNode } from 'react';

/*
 * Verzia v bocnom paneli.
 *
 * Ukazuje verziu, ktoru hlasi BRANA, nie tu zabudovanu v rozhrani. Ked
 * sa lisia, znamena to, ze prehliadac drzi stary balik - a prave to je
 * pripad, ked pouzivatel nevidi funkciu, ktora uz existuje. Preto sa to
 * povie nahlas, nie sa to skryje.
 */

interface Verzie {
  readonly brana: string | undefined;
  readonly rozhranie: string;
}

export function Verzia(): ReactNode {
  const [verzie, setVerzie] = useState<Verzie>({ brana: undefined, rozhranie: __APP_VERSION__ });

  useEffect(() => {
    const controller = new AbortController();
    fetch('/readyz', { signal: controller.signal })
      .then(async (r) => (await r.json()) as { version?: unknown })
      .then((data) => {
        if (typeof data.version === 'string') {
          setVerzie((v) => ({ ...v, brana: data.version as string }));
        }
      })
      .catch(() => {
        // Nedostupny server sa hlasi na obrazovke Systém, nie tu.
      });
    return () => controller.abort();
  }, []);

  const zastarane = verzie.brana !== undefined && verzie.brana !== verzie.rozhranie;

  /*
   * Skratka na obnovenie sa medzi systemami lisi a zla rada je horsia
   * nez ziadna: na macOS to nie je Ctrl, ale Cmd. Safari navyse tvrde
   * obnovenie klasickou skratkou nema - tam je to Cmd+Option+E
   * (vyprazdnit cache) a potom obnovit.
   */
  const mac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
  const safari =
    typeof navigator !== 'undefined' &&
    /Safari/.test(navigator.userAgent) &&
    !/Chrome|Chromium|Edg/.test(navigator.userAgent);
  const skratka = safari
    ? 'v Safari: Cmd+Option+E a potom Cmd+R'
    : mac
      ? 'Cmd+Shift+R'
      : 'Ctrl+Shift+R';

  return (
    <div className="flex flex-col gap-1 px-3 pb-1 text-xs">
      <span className="text-(--color-text-subtle)">LoxLink {verzie.brana ?? verzie.rozhranie}</span>
      {zastarane && (
        <span role="status" className="text-(--color-warn)">
          Rozhranie je z verzie {verzie.rozhranie}. Obnov stránku ({skratka}).
        </span>
      )}
    </div>
  );
}
